import { addParameterToUrl as e, getParameterFromUrl as t, removeParamsFromUrl as n } from "../utils/url.js";
import { c as r } from "react/compiler-runtime";
import { useState as i } from "react";
//#region src/hooks/usePagination.ts
var a = 1, o = 24, s = "page", c = "pageSize";
function l(n, l) {
	let f = r(17), p = l === void 0 ? o : l, [m, h] = i(n), g;
	f[0] === Symbol.for("react.memo_cache_sentinel") ? (g = t(s, !0, !1) || a, f[0] = g) : g = f[0];
	let [_, v] = i(g), y;
	f[1] === p ? y = f[2] : (y = t(c, !0, !1) || p, f[1] = p, f[2] = y);
	let [b, x] = i(y), S;
	bb0: {
		if (m !== void 0) {
			S = Math.max(1, Math.ceil(m / b));
			break bb0;
		}
		S = void 0;
	}
	let C = S, w;
	bb1: {
		if (C === void 0 || _ <= C) {
			w = _;
			break bb1;
		}
		w = C;
	}
	let T = w, [E, D] = i(T);
	T !== E && (D(T), T !== _ && (v(T), e(s, T.toString(), !1)));
	let O = Math.max(0, (T - 1) * b), k;
	f[3] === Symbol.for("react.memo_cache_sentinel") ? (k = (t) => {
		v(t), e(s, t.toString(), !1);
	}, f[3] = k) : k = f[3];
	let A = k, j;
	f[4] === Symbol.for("react.memo_cache_sentinel") ? (j = (t) => {
		x(t), e(c, t.toString(), !1);
	}, f[4] = j) : j = f[4];
	let M = j, N = u, P;
	f[5] === Symbol.for("react.memo_cache_sentinel") ? (P = () => {
		A(a);
	}, f[5] = P) : P = f[5];
	let F = P, I;
	f[6] !== O || f[7] !== b ? (I = (e) => d(e, b, O), f[6] = O, f[7] = b, f[8] = I) : I = f[8];
	let L = I, R;
	f[9] === m ? R = f[10] : (R = (e) => {
		e !== m && h(e);
	}, f[9] = m, f[10] = R);
	let z = R, B;
	return f[11] !== T || f[12] !== O || f[13] !== b || f[14] !== L || f[15] !== z ? (B = {
		offset: O,
		currentPage: T,
		pageSize: b,
		onPageChange: A,
		onPageSizeChange: M,
		syncTotalElements: z,
		queryWithPagination: L,
		resetPage: F,
		removePageFromUrl: N
	}, f[11] = T, f[12] = O, f[13] = b, f[14] = L, f[15] = z, f[16] = B) : B = f[16], B;
}
function u() {
	n([s]);
}
var d = (e, t, n = 0) => ({
	...e,
	offset: n,
	limit: t ?? o
});
//#endregion
export { d as addPaginationParams, l as usePagination };
